// Home page hero section . If 1 slider => stop swiping
var heroSliderCount = $(".hero-swiper .swiper-slide").length;

if (heroSliderCount == 1) {
  $('.hero-swiper .swiper-wrapper').addClass("disabled");
  $('.hero-swiper .paggination').addClass("disabled");
} else {
  var swiper = new Swiper(".hero-swiper", {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".paggination",
      clickable: true,
    },
    navigation: {
      nextEl: ".btn--next",
      prevEl: ".btn--prev",
    },
    on: {
      init: function(){
        let height = $('.paggination').height();
        $('.paggination-count').html(`<p class="slide-count">${this.realIndex + 1}</p>`);
        $('.paggination-count').css({'bottom': `${height + 42}px`})
      },
      slideChange: function(){
        let height = $('.paggination').height();
        $('.paggination-count').html(`<p class="slide-count">${this.realIndex + 1}</p>`);
        $('.paggination-count').css({'bottom': `${height + 42}px`})
      }
    }
  });
}

// Slider with paggination and navigation . If 1 slider => stop swiping
var heroSliderCount2 = $(".swiper-pagginatio-nav .swiper-slide").length;

if (heroSliderCount2 == 1) {
  $('.swiper-pagginatio-nav .swiper-wrapper, .swiper-pagginatio-nav .paggination').addClass("disabled");
} else {
  var swiper2 = new Swiper(".swiper-pagginatio-nav", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    speed: 200,
    slidersPerView: 1,
    pagination: {
      el: ".paggination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

}

// Slider with paggination and navigation . If 1 slider => stop swiping
var heroSliderCount3 = $(".swiper-pagginatio-navs .swiper-slide").length;

if (heroSliderCount3 == 1) {
  $('.swiper-pagginatio-navs .swiper-wrapper, .swiper-pagginatio-navs .pagginations').addClass("disabled");
} else {
  var swiper3 = new Swiper(".swiper-pagginatio-navs", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    speed: 200,
    slidersPerView: 1,
    pagination: {
      el: ".pagginations",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

}


var slidesCount = $(".simple-slider .swiper-slide").length;

if (slidesCount == 1) {
  $('.swiper-wrapper').addClass("disabled");
  $('.swiper-pagination').addClass("disabled");
} else {
  var swiper = new Swiper(".simple-slider", {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
